/**
 * @returns whatever location string is available for a given event
 */
export default function normalizeLocation({
    location = '',
    locationAddress = '',
    locationLink = '',
}): string {
    return locationAddress || locationLink || location || ''
}
